<template>
  <div class="financials">
    <h2>Bootstrapped version of financial forecast</h2>
    <div class="table-container" v-if="forecastComplete">
      <div class="column-flex">
        <div class="stats-container custom-container">
          <div class="stats-top-text">Define variables</div>
          <div class="column-flex stats-box">
            <span>Investment</span>
            <input type="checkbox" id="checkbox" v-model="investment" />
          </div>
          <div class="column-flex stats-box" v-if="investment">
            <span>Investment size</span>
            <input type="number" v-model.number="investmentSize" />
          </div>
          <div class="column-flex stats-box">
            <span>Avg nr of page views to an ad location per user per day</span>
            <input type="number" v-model.number="avgViewsDayPerUser" />
          </div>
          <div class="column-flex stats-box">
            <span>Avg. visit duration per page view in minutes</span>
            <input type="number" v-model.number="avgDurationPerView" />
          </div>
          <div class="column-flex stats-box">
            <span>Avg. CPM (€)</span>
            <input type="number" v-model.number="avgCPM" />
          </div>
          <div class="column-flex stats-box">
            <span>Retention %</span>
            <input type="number" v-model.number="retentionPercentage" />
          </div>
          <div class="column-flex stats-box">
            <span>Weekly growth rate %</span>
            <input type="number" v-model.number="weeklyGrowthPercentage" />
          </div>
          <div class="column-flex stats-box">
            <span>Avg. CPM growth rate %</span>
            <input type="number" v-model.number="CPMGrowthRate" />
          </div>
          <div class="column-flex stats-box">
            <span>Premium cost/month</span>
            <input type="number" v-model.number="premiumPrice" />
          </div>
          <div class="stats-top-text">Define variable caps</div>
          <div class="column-flex stats-box">
            <span>CPM growth rate cap</span>
            <input type="number" v-model.number="CPMGrowthRateCap" />
          </div>
          <div class="column-flex stats-box">
            <span>Growth rate cap (%/week)</span>
            <input type="number" v-model.number="growthRateCap" />
          </div>
          <div class="column-flex stats-box">
            <span>Retention cap (%/month)</span>
            <input type="number" v-model.number="retentionRateCap" />
          </div>
        </div>
        <!--         <div class="recalc" @click="constructFinancialForecast">
          Recalculate forecast
        </div> -->
      </div>
      <table>
        <thead>
          <tr>
            <th class="head-title revenue">Revenue</th>
            <th v-for="(month, i) in months" :key="i">{{ month.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="title-cell">Advertising</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.revenue.advertising) }}
            </td>
          </tr>
          <tr>
            <td class="title-cell">Supporters / Premium</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.revenue.premium) }}
            </td>
          </tr>
          <tr v-if="investment">
            <td class="title-cell">External investments</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.revenue.investment) }}
            </td>
          </tr>
          <!--           <tr>
            <td class="title-cell">Marketplace & gamification sales</td>
            <td></td>
            <td class="money-box" v-for="(month, i) in months" :key="i">€0</td>
          </tr>
          <tr>
            <td class="title-cell">New external investments</td>
            <td></td>
            <td class="money-box" v-for="(month, i) in months" :key="i">€0</td>
          </tr>
          <tr>
            <td class="title-cell">Revenue-based financing</td>
            <td></td>
            <td class="money-box" v-for="(month, i) in months" :key="i">€0</td>
          </tr> -->
          <tr>
            <th class="head-title-2">Subtotal</th>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.revenue.total) }}
            </td>
          </tr>
          <tr class="special-2">
            <th class="head-title"></th>
            <td class="special-box-2" v-for="(month, i) in months" :key="i"></td>
          </tr>
          <tr>
            <th class="head-title expenses">Expenses</th>
          </tr>
          <tr>
            <td>Software Development</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.development) }}
            </td>
          </tr>
          <tr>
            <td>Sales & Marketing</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.marketing) }}
            </td>
          </tr>
          <tr>
            <td>Servers & database costs</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.serverDBexpenses) }}
            </td>
          </tr>
          <tr>
            <td>Legal & Other</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.legal) }}
            </td>
          </tr>
          <tr>
            <td>General & Administrative</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.salaries) }}
            </td>
          </tr>
          <tr>
            <th class="head-title-2">Total spent</th>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(month.expenses.total) }}
            </td>
          </tr>
          <tr class="special-2">
            <th class="head-title"></th>
            <td class="special-box-2" v-for="(month, i) in months" :key="i"></td>
          </tr>
          <tr>
            <th class="head-title">Cash flow</th>
            <td class="money-box" v-for="(month, i) in months" :key="i">€{{ numberWithCommas(month.cashflow) }}</td>
          </tr>
          <tr>
            <th class="head-title">Cash balance</th>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              €{{ numberWithCommas(Math.trunc(month.cashbalance)) }}
            </td>
          </tr>

          <tr class="special">
            <th class="head-title"></th>
            <td class="special-box" v-for="(month, i) in months" :key="i"></td>
          </tr>
          <tr>
            <th class="head-title variables">Variables</th>
          </tr>

          <tr>
            <td class="title-cell">Nr of users</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(Math.trunc(month.otherData.nrOfUsers)) }}
            </td>
          </tr>
          <tr>
            <td class="title-cell">Nr of active users</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(Math.trunc(month.otherData.nrOfUsers * (month.otherData.retentionRate / 100))) }}
            </td>
          </tr>
          <tr>
            <td class="title-cell">Total views month</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(Math.trunc(month.otherData.nrOfUsers * month.otherData.nrOfViewsPerDay * 30)) }}
            </td>
          </tr>
          <tr>
            <td>Avg. views per user per day</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(Number(month.otherData.nrOfViewsPerDay).toFixed(2)) }}
            </td>
          </tr>
          <tr>
            <td>Avg. duration per view per user</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(month.otherData.durationPerView.toFixed(2)) }}
            </td>
          </tr>
          <tr>
            <td>Avg. CPM (€)</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(month.otherData.CPM.toFixed(2)) }}
            </td>
          </tr>
          <tr>
            <td>Retention % of users</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(month.otherData.retentionRate) }}%
            </td>
          </tr>
          <tr>
            <td>Weekly growth rate</td>
            <td class="money-box" v-for="(month, i) in months" :key="i">
              {{ numberWithCommas(month.otherData.growthRate.toFixed(2)) }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-container">
      <div class="core-info">
        <div>
          <h2>Today</h2>
          <div class="container">
            <div class="stats-container">
              <span class="stats-top-text">Sign ups</span>
              <span class="stats-number">21,000+</span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Daily active users</span>
              <span class="stats-number">1000+</span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Monthly active users</span>
              <span class="stats-number">7000+</span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Nr of countries</span>
              <span class="stats-number">179+ </span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Avg. engagement time</span>
              <span class="stats-number">15min+</span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Time spent in sessions</span>
              <span class="stats-number">73,500+ hours </span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Followers on TikTok</span>
              <span class="stats-number">98,000+</span>
            </div>
            <div class="stats-container">
              <span class="stats-top-text">Views on TikTok</span>
              <span class="stats-number">2.2M+</span>
            </div>
          </div>
        </div>
        <div class="section-container">
          <h2>How this forecast works</h2>
          <div>
            We have built this forecast in relation to our development plans, our marketing plans (and track record),
            what users have demanded and metrics that are under our influence — that is, the number of users we have,
            how many of them are active, how many return, our weekly growth rate, the number of views users may
            generate, the amount of time they are likely to spend on any given page, our demographics and how high the
            purchasing power is in our target areas — combined with our predictions for how these variables will change
            with continued development efforts of building new highly engaging areas and with continued marketing
            efforts.
          </div>
          <div class="formulaToggle" @click="showFormula = !showFormula">
            Click to view formula breakdown
          </div>
          <div v-if="showFormula" class="roadmap-item">
            <div
              style="font-size: 18px; margin-top: 20px; text-transform: uppercase; font-weight: 700; line-height: 26px; letter-spacing: 0px; font-family: 'Palantino';"
            >
              (Avg. views per user/day * (Avg. duration per view in minutes * 60 / Refresh Rate +1)) * Nr of users * 30
              / 1000 * Avg. CPM
            </div>
            <div style="margin-top:10px; font-weight: 700;">
              Revenue formula breakdown
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                Avg. duration per view * 60 / Refresh Rate + 1 = Impressions per view (due to ad refresh, which allows
                displaying another ad after a certain amount of seconds have passed, we have set it to be 60 seconds
                currently, hence also the conversion of minutes to seconds), +1 is one impression as the default per
                view, additional views are counted as how many refreshes can happen within the time a user spends on a
                page.
              </li>
              <li class="classic-list-item">
                Avg. views per user/day * Impressions per view = Total impressions per user per day
              </li>
              <li class="classic-list-item">
                Total impressions per user per day * Nr of users = Total impressions across all users in a day
              </li>
              <li class="classic-list-item">
                Total impressions across all users in a day * 30 = Total impressions across all users in a month
              </li>
              <li class="classic-list-item">
                Total impressions across all users in a month / 1000 * Avg. CPM = Revenue per 1000 impressions
              </li>
            </ul>
            <div style="margin-top:10px; font-weight: 700;">
              Increases formula
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                We increase retention rate by 6% each month until cap of 40% is reached, which is considered a high
                retention rate.
              </li>
              <li class="classic-list-item">
                We increase weekly growth rate by 1% each month until cap of 10% is reached, which is considered a great
                rate.
              </li>
              <li class="classic-list-item">
                After adding the first highly engaging layer to the app that can also host an ad, we increase average
                number of views to an ad location by 500% and duration per view by 50% the first time around (based on
                observations of how many people check profiles and their messenger, areas with relatively high
                engagement rates even now). The second and third high engagement area will respectively increase these
                numbers 100% and 30% and 50% and 25% by the third. At this stage, we believe a very high engagement is
                achieved, where after which the average views per user per day grow by 5 views until a cap of 30 is
                achieved, after which the average views per user per day increase by 0.3 views per month. Duration per
                view will be increased 0.5 minutes every month until an average of 5 minutes is reached, after which we
                increase it by 0.2 minutes every month.
              </li>
              <li class="classic-list-item">
                CPM is flatly increased by €0.05/month.
              </li>
              <li class="classic-list-item">
                Supporter/premium subscribers count is increased by 0.5/month with starting price is €3/month. We
                currently have 20 supporters through BuyMeACoffee who each pay €3/month to get an ad-free experience and
                support us.
              </li>
              <li class="classic-list-item">
                For every €4,000 that we have, we would add another theoretical developer to the team. For every
                developer, we consider a new area can be created with a cap of 5 areas/month with a slowing factor of
                every 4th developer requiring an additional Quality Assurance developer that ensures there are no bugs.
                We don't plan on hiring managers and believe the Software Architect of the team knows best what the
                capabilities of their team are, and likewise what each developer can do and therefore what deadlines
                should be set.
              </li>
            </ul>
            <div style="margin-top:10px; font-weight: 700;">Expenses</div>
            <ul class="classic-list">
              <li class="classic-list-item">
                Expenses set to roughly spend 90% on software development related expenses, 10% on sales & marketing and
                once revenue reaches €35,000+, we pay ourselves salaries of €1,000/each out of the software development
                budget.
              </li>
            </ul>
            <div style="margin-top:10px; font-weight: 700;">In the case of investment</div>
            <ul class="classic-list">
              <li class="classic-list-item">
                Until revenue achieves target of €10,000, we put 0.08% of total cash balance into development and 0.04%
                of cash balance into marketing efforts. After that is achieved, we would increase the development budget
                to 90% of cash balance into development, and put 10% into marketing from thereon forward.
              </li>
              <li class="classic-list-item">
                We would increase growth rate by 30% of the investment divided by 25,000. This is to reflect approximate
                effect of the expected results of increased marketing spend.
              </li>
              <li class="classic-list-item">
                We would increase growth rate by 30% of the investment divided by 25,000. This is to reflect approximate
                effect of the expected results of increased marketing spend.
              </li>
              <li class="classic-list-item">
                We would increase CPM increase by an additional €0.05/month for an investment between 50K-200K.
                €0.1/month for an investment between €200K and €500K. €0.15/month for anything above €500K. This is also
                to reflect an approximate effect of how increased marketing spend would increase average CPM.
              </li>
              <li class="classic-list-item">
                We give ourselves salary €1,000/month each.
              </li>
              <li class="classic-list-item">
                We give ourselves salary €1,000/month each.
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              Two core predictions
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                We predict we can keep up a steady growth rate of new users at 5% a week and we predict we can increase
                this rate at least up to 10% a week within the 18 month timeline. Such a growth rate is also not unusual
                in our niche by any means, as it is fundamentally social (not just about productivity).
              </li>
              <li class="classic-list-item">
                We predict we can build at least one highly engaging area every 1-2 months (and more if we are able to
                add more developers to our team) that will impact our engagement up to several hundred times in the
                first few months after adding the first few highly engaging areas. We also predict these areas will
                greatly impact long-term retention rates. We also intend to build every new area such that it compounds
                the existing value we already offer on the platform. One feature alone may do great, however certain
                features existing together and working in sync can achieve a lot more. If we can add more developers to
                our team, we can accelerate this greatly.
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              The Present
            </div>
            <div style="margin-bottom: 10px;">
              Until now, we've primarily focused on refining our booking and video call experience. But that's mostly
              all they do, because there's not many other things to do yet. People do check profiles a lot and they use
              our in-app messenger and even the community is getting action, but for the most part, we've not yet had a
              chance to work on engagement and these areas need some redesigning to aesthetically fit an ad.
            </div>
            <div style="margin-bottom: 10px;">
              As such, our upcoming focus for the next few upcoming months is building layers to the application that
              are designed to significantly increase engagement. This means a gamification layer, a significantly
              stronger social layer, personal study tools, etc.
            </div>
            <div
              style="margin-bottom: 10px; font-weight: 600; padding: 3px; background-color: #dbe7cc; border-radius: 8px;"
            >
              The first such layer we predict we'll be able to release before the end of May, and therefore will already
              begin reaping the benefits of it from June onwards — hence the big jump in revenue starting june. As it
              will be our first highly engaging area where we can also have an ad, and we based on existing user
              interactions and observations of user behavior in competing solutions, such increase is our prediction of
              activity increase. However, even if the initial growth speed would not increase this much, it would not
              take long to reach similar numbers even by a smaller % growth rate.
            </div>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              How do we know we'll get all these people at such a growth rate?
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                The market is large and rapdily growing, consisting of not just students but also freelancers (including
                writers, developers, designers, etc.), people with ADHD and virtually anyone looking to be more
                productive in company or looking to meet people who they can exchange interactions related to
                productivity.
              </li>
              <li class="classic-list-item">
                Right now, hundreds of thousands of people are still scattered across Discord and Slack servers,
                Study/Work With Me livestreams on YouTube and equivalent. TikTok study, ADHD, productivity and freelance
                communities have tens of millions of people interested in. Millions of people watch Study/Work With Me
                videos and livestreams on YouTube.
              </li>
              <li class="classic-list-item">
                Not only is the market large — reaching them is very doable. We have organically gathered an audience of
                98K+ followers on TikTok in about 6 months through creating content that appeals to our target audiences
                and we have reached several million people. With the existing videos we've made, we would be gaining
                50-100 sign ups/day even if we did nothing. The 21,000 users we've gained have been in the past 6 months
                and we're getting better at TikTok, which is what allowed us to gain an additional 4,000 sign ups over
                the last week.
              </li>
              <li class="classic-list-item">
                Many companies that are no better than us are consistently able to generate insanely great results on
                TikTok with tens of millions of people reached monthly. If we are to engage additionally in paid
                partnerships, our growth rate can increase significantly.
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              How do we know these areas will be highly engaging?
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                We are in constant communication with our community. We've polled them, we hear them, we talk with them
                daily. We are part of the community, and we are also the target user ourselves. As such, we know and
                understand our users, we know what they need, what they want and what they'll want next.
              </li>
              <li class="classic-list-item">
                The next layer we seek to build is gamification. We know this will work well because our users already
                go to crazy lengths to get the badges we have today, to find them and they request for more. Our users
                demand for more gamification. We want gamification ourselves. And we've seen how well gamification has
                worked for another social productivity app called Habitica.
              </li>
              <li class="classic-list-item">
                The layer after that we intend to build is an extensive social layer. Our observations of existing ways
                people are solving their needs today suggest that the activities surrounding studying-working together
                are happening as much, if not more than the actual studying-working.
                <ul class="classic-list" style="margin:5px 0px;">
                  <li class="classic-list-item">
                    People in massive Discord/Slack channels — with hundreds of thousands of members, consisting of our
                    target audience — love exchanging their favorite productivity music, what they're reading, watching,
                    showing off their study/work setups, sharing their goals and accomplishments, talking about their
                    challenges, complaining, supporting others and giving advice, posting motivational-inspirational
                    content.
                  </li>
                  <li class="classic-list-item">
                    Yet both Discord and Slack are clunky and inconvenient for such activities and a much greater place
                    can be designed to facilitate all of that. We want to further facilitate all that rich discussion
                    and also as quickly as possible move away from just productivity, to doing things together in
                    general, on video call.
                  </li>
                </ul>
              </li>
              <li class="classic-list-item">
                People love what we've made so far. They send us emails, make community posts, send us messages about
                how much they love Cofocus, thanking us and saying how it's completely changed their lives around.
              </li>
            </ul>
          </div>
          <h2 style="margin-top:30px;">
            Why the advertising business model works for Cofocus
          </h2>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              An ads based business model could be summed up in these two strategies (which we've predicted we will be
              able to do successfully):
            </div>
            <ul class="classic-list" style="margin:5px 0px;">
              <li class="classic-list-item">
                Increase the number of valuable areas in the app that people love and would like to use to increase
                engagement (views, duration per view)
              </li>
              <li class="classic-list-item">
                Increase the value of each area to a higher % of people to increase the amount of time a user spends in
                any given area (duration per view)
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              The nature of Cofocus is made for ads, because it is:
            </div>
            <ul class="classic-list" style="margin:5px 0px;">
              <li class="classic-list-item roman-list">
                A fundamentally social platform (e.g. not just a productivity tool);
              </li>
              <li class="classic-list-item roman-list">
                In a large market that we know how to reach;
              </li>
              <li class="classic-list-item roman-list">
                And we're about to add a significantly stronger social layer to it;
              </li>
              <li class="classic-list-item roman-list">
                Social platforms thrive on the advertising business model.
              </li>
              <li class="classic-list-item roman-list">
                Our most active users (who generate rougly 80% of our impressions) are from countries with the highest
                purchasing power and therefore highest CPM rates in the world (USA, UK, Australia, New Zealand,
                Singapore, Western & Northern Europe), with rates between €2.5-€5 on average.
              </li>
            </ul>
            <div>
              The advertisement model would be a problem if it were a small market or if it were very difficult to bring
              on new users. Neither is the case for Cofocus. The number of people interested is vastly larger than the
              number of people likely to be willing or able to pay. Meanwhile the overall purchasing power of these
              users (and therefore value to advertisers) far surpasses the amount one could reasonably charge for a
              subscription, even if every single one of these users were a paying member.
            </div>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              What makes the ads business model so powerful in general
            </div>
            <ul class="classic-list" style="margin:5px 0px;">
              <li class="classic-list-item">
                The value of each user can increase over time, as the more people use our platform, the more valuable we
                are to advertisers and therefore our CPM (earnings per 1000 impressions) grows. CPMs can go as high as
                €10. More revenue from the same user base over time. This cannot happen to this extent with a
                subscription-only model.
              </li>
              <li class="classic-list-item">
                Keeping the core experience of the platform "free" allows for far more explosive growth and popularity
                (scale). It also allows capturing users that otherwise might go to competitors.
              </li>
              <li class="classic-list-item">
                There are significantly more variables that one can play with to increase revenue, including just the
                possibility of creating an additional valuable section inside the application that can accommodate an ad
                that can 'overnight' add a significant increase to revenue (or allow capturing a novel target group).
                With a subscription-only model, adding an additional valuable section to the platform does not add any
                direct business value other than the possibility of attracting more customers to a premium plan.
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              We're not restricted to ads only
            </div>
            <ul class="classic-list">
              <li class="classic-list-item">
                Our business model is also in no means restricted to ads only, rather it can co-exist. Those who are
                willing and can pay, can have a superior experience. Others have ads and fewer advanced user features.
                And we already know the subscription model works due to our competitors all being subscription-only
                oriented, however if the ads model will work and we grow fast enough, we'll be able to win against any
                subscription-based competitor. Here are some premium and marketplace business models that we can
                develop:
                <ul class="classic-list" style="margin:5px 0px;">
                  <li class="classic-list-item">
                    Solo study tools/workspaces/digital workdesk or an enhanced versions of them (task managers, habit
                    trackers, time trackers, planners, journals).
                  </li>
                  <li class="classic-list-item">
                    More advanced statistics.
                  </li>
                  <li class="classic-list-item">
                    Marketplace for different ambiences, themes, sounds (which possibly users can also create), selling
                    themes and sounds has already worked for some of our competitors.
                  </li>
                  <li class="classic-list-item">
                    Create private communities, sell membership to them, host events with your community. Get your team
                    on your own private digital co-working hub.
                  </li>
                  <li class="classic-list-item">
                    Remove ads.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="roadmap-item special-top">
            <div style="font-size: 18px; font-weight: 600; margin-top:20px;">
              Example against the subscription model using the calculator below
            </div>
            <ul class="classic-list" style="margin:5px 0px;">
              <li class="classic-list-item">
                You need 10,000 users from a high CPM country (such as €2.5/per thousand views), generating about 450
                views a month (15 views/day) and spending on average 3 minutes on each page to make €45,000/month. You
                would need 9000 users paying €5/month or 4500 users paying €10/month to achieve the same.
              </li>
              <li class="classic-list-item">
                Except that to gain paying users is far harder than attracting large crowds to the solution. And as the
                app grows and gets better and becomes more valuable to users, the number of views users generate on
                average would increase, the time spent per page would increase and our value to advertisers grows
                (therefore CPM increases).
              </li>
            </ul>
          </div>
        </div>
        <div class="flex">
          <div class="column-flex">
            <div class="stats-container custom-container">
              <div class="stats-top-text">Define active user</div>
              <div class="column-flex stats-box">
                <span>Nr of page views user generates per month to an ad location:</span>
                <input type="number" v-model.number="monthlyViewsPerActiveUser" />
              </div>
              <div class="column-flex stats-box">
                <span>Avg. visit duration per page view in minutes:</span>
                <input type="number" v-model.number="averageDurationPerViewInMinutes" />
              </div>
            </div>
            <div class="stats-container custom-container">
              <div class="stats-top-text">Define factors</div>
              <div class="column-flex stats-box">
                <span>Nr of active users</span>
                <input type="number" v-model.number="nrOfActiveUsers" />
              </div>
              <div class="column-flex stats-box">
                <span>CPM rate (€)</span>
                <input type="number" v-model.number="CPM" />
              </div>
            </div>
          </div>
          <div class="column-flex">
            <div class="stats-container custom-container">
              <span class="stats-top-text">Potential revenue</span>
              <span class="stats-number">€{{ potentialRevenue }}/month</span>
            </div>
            <div class="stats-container custom-container">
              <span class="stats-top-text">Revenue breakdown</span>
              <span class="stats-top-text">Non-refresh revenue share: {{ regularViewPercentageOfRevenue }}%</span>
              <span class="stats-top-text">Refresh revenue share: {{ refreshPercentageOfRevenue }}%</span>
            </div>
            <div class="stats-container custom-container">
              <span class="stats-top-text">Comparison to subscription-only model</span>
              <span>To make the same with a subscription-only based model requires paying</span>
              <div style="font-size: 20px; margin: 5px 0px;">
                <span>€</span
                ><input
                  style="margin: 0 5px; font-size: 20px; width: 40px;"
                  type="number"
                  v-model.number="subscriberFee"
                /><span>by {{ computeSubscribersCount }} users.</span>
              </div>
              <div style="font-size: 14px; line-height: 17px; margin-top: 10px;">
                This also does not account for the fact that an ad-centric model can still have subscriptions and other
                business models working in parallel.
              </div>
            </div>
          </div>
        </div>
        <div class="section-container">
          <h2>Explanation</h2>
          <ul class="classic-list">
            <li class="classic-list-item">
              With an ad refresh interval of displaying a new ad per 60 seconds and an average duration of
              {{ averageDurationPerViewInMinutes || 0 }} minutes per page view
            </li>
            <li class="classic-list-item">
              It adds up to an average of {{ totalNrOfAdsRunPerImpression }} ad impressions per page view and a total of
              {{ totalNrOfAdsRunPerImpression * monthlyViewsPerActiveUser }}
              ad impressions per month per active user that generates
              {{ monthlyViewsPerActiveUser }} page views per month (equivalent of ≈{{
                Math.round(monthlyViewsPerActiveUser / 30)
              }}
              page views/day per such user).
            </li>
            <li class="classic-list-item">
              With a CPM rate of €{{ CPM }} per 1,000 impressions, this would value each page view of such an user at
              €{{ revenuePerPageView }} and total revenue from such user of €{{
                totalNrOfAdsRunPerImpression * monthlyViewsPerActiveUser * (CPM / 1000)
              }}
              per month.
            </li>
            <li class="classic-list-item">
              With {{ nrOfActiveUsers }} monthly active users like this, it adds up to a total of
              {{ totalNumberOfImpressionsMonth }} impressions a month across all users. That would generate €{{
                potentialRevenue
              }}/month.
            </li>
          </ul>
        </div>
        <div class="section-container">
          <h2>Testimonials</h2>
          <div class="testimonials">
            <img class="testimonial" v-for="(testimonial, i) in testimonials" :key="i" :src="testimonial" />
          </div>
        </div>
        <div class="section-container">
          <h2>Roadmap</h2>
          <div>Exactly what we plan to do, why and the expected outcomes.</div>
          <div class="roadmap-item">
            <div class="roadmap-month">May</div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Development</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Gamification layer
                  <ul class="roadmap-sublist">
                    <li class="roadmap-list-item">
                      Personal statistics dashboard
                    </li>
                    <li class="roadmap-list-item">
                      A global leaderboard
                    </li>
                    <li class="roadmap-list-item">
                      Rewards & penalties (levels and XP points, badges) — and this comes with in-app challenges and
                      achievements one can unlock by doing certain actions, including participating in the community.
                    </li>
                    <li class="roadmap-list-item">
                      Streaks
                    </li>
                    <li class="roadmap-list-item">
                      Community challenges area
                    </li>
                    <li class="roadmap-list-item">
                      Profiles reflecting achievements and participations in challenges
                    </li>
                    <li class="roadmap-list-item">
                      Means to share/publish one's accomplishments and get praise, feedback, congratulations.
                    </li>
                    <li class="roadmap-list-item">
                      Notifications, including for when someone achieves something and getting a push to congratulate
                      them (while generating an ad impression or several).
                    </li>
                  </ul>
                </li>
              </ul>
              <div class="roadmap-section-small">
                <div class="roadmap-section-title-small">Why</div>
                <ul class="roadmap-list">
                  <li class="roadmap-list-item-small">
                    Gamification incentivizes behaviors that we predict leads to fewer no-shows inside sessions, better
                    experiences for both new existing users, which leads to overall higher user satisfaction, increasing
                    conversion and retention.
                  </li>
                  <li class="roadmap-list-item-small">
                    Leaderboards, levels and points create healthy competition, comparison and looking into other
                    peoples achievements and gives users another thing to bond over and discuss, strengthening in-app
                    relationships and increasing engagement. Essentially, it creates buzz and a more engaged community,
                    while also serving as a motivator for getting things done.
                  </li>
                  <li class="roadmap-list-item-small">
                    Increased incentives to generally take more actions on the platform (that we'd like them to, but
                    that also benefit them), more reasons to return and more reasons to stay (to keep progress) and more
                    things to check, meaning increased engagement and retention.
                  </li>
                  <li class="roadmap-list-item-small">
                    More areas with frequently changing information that is potentially relevant and compelling to
                    people creates more incentives to look around and go back and forth between sections of the app, and
                    more incentives to spend time looking at the different statistics, which will increase revenue.
                  </li>
                  <li class="roadmap-list-item-small">
                    Growing one's achievements likely get users more invested in the platform, making it harder to
                    leave. And competing against others means one doesn't want to fall behind. And later one might not
                    want to lose those connections and bonds, keeping one wanting to come back and having high loyalty
                    to the app.
                  </li>
                  <li class="roadmap-list-item-small">
                    Gamification, as we plan it, with smartly done cues, aesthetic visuals and catchy sounds is also
                    likely to create at least some forms of addiction through rewards and gratification, and possibly
                    even by publicly displaying and sharing one's accomplishments (as a post) and having people
                    congratulate each other (positive feedback and addicting validation).
                  </li>
                </ul>
                <div class="roadmap-section-title-small">Why now</div>
                <ul class="roadmap-list">
                  <li class="roadmap-list-item-small">
                    Until now, we've primarily focused on refining the booking and in-session experience. We haven't put
                    enough attention to everything that surrounds it. We saw the positive results when we created the
                    onboarding flow, the way it increased successful sessions, minimized questions and
                    misunderstandings, lessened negative first experiences as people understood the format correctly.
                    And now our next step is to increase overall engagement but also retention, as too small a
                    percentage of users have stayed with us and this is one of our biggest problems. Make Cofocus as
                    rewarding, engaging and addicting of an experience as possible and maximize to how many our offering
                    is of interest.
                  </li>
                  <li class="roadmap-list-item-small">
                    This is one of the most high impact feature sets we can develop to increase engagement and user
                    activity that is also simultaneously highly relevant to user experience (and therefore also
                    retention and conversion). This is more relevant and important to develop than the social layer,
                    because this directly impacts the core experience of the app (sessions), primarily by likely greatly
                    increasing successfully attended sessions, which will also set better ground for the social layer.
                    Meanwhile getting our existing core app experience right first is more important than creating new
                    productivty functions.
                  </li>
                  <li class="roadmap-list-item-small">
                    And right now, we <span style="font-style: italic;">really</span> need to rapidly increase user
                    interactions on the platform, user loyalty (retention) and good experiences (conversion, retention,
                    lower churn) and capturing new joiners better and converting them to regular users, to ultimately
                    maximize the number of users using the app and maximize the number of page views they generate and
                    how much time they spend on each page — as the better we can impact these variables, the higher the
                    revenue we can achieve faster and therefore the faster we can hire help and build more of what users
                    love but also more of what will drive these metrics even higher. And the ways gamification improves
                    nearly every aspect of the Cofocus experience, will allow every consecutive functionality to bring
                    out compounding value from gamification.
                  </li>
                </ul>
              </div>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Marketing</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Produce and publish ≈1 targeted audience TikTok video/day that uses a trending sound.
                </li>
                <li class="roadmap-list-item">
                  Community social media challenge that would lead people to making TikTok videos about Cofocus, even if
                  it is a testimonial.
                </li>
              </ul>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Community</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Weekly email campaign/funnel with the goal to re-engage old sign ups.
                </li>
                <li class="roadmap-list-item">
                  Weekly community poll to engage people in the conversation and increase factors of belonging, sense of
                  community, having a voice and influence, fostering relations.
                </li>
              </ul>
            </div>
            <div class="roadmap-outcomes">
              <div class="roadmap-section-title">Expected outcomes by end of June</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  5x increase in page views to ad locations by target user groups (from average of 2 page views/day to
                  15+).
                </li>
                <li class="roadmap-list-item">
                  Increase in duration of each page view by target user groups for pages with an ad to 3 minutes on
                  average.
                </li>
                <li class="roadmap-list-item">
                  5K+ new sign ups.
                </li>
                <li class="roadmap-list-item">
                  10% increase in retention (=> more DAU/MAU, less churn).
                </li>
                <li class="roadmap-list-item">
                  10% increase in conversion (=> more DAU/MAU, less churn).
                </li>
                <li class="roadmap-list-item">
                  10% existing userbase re-engaged (=> more DAU/MAU).
                </li>
              </ul>
              <div class="roadmap-section-title">Comments</div>

              <ul class="roadmap-list">
                <li class="roadmap-list-item-small">
                  Since the functionality will be developed in May (and released gradually), the results will start
                  showing up after first releases in May and begin compounding in June as more people discover and begin
                  benefitting from and getting hooked to the gamification, and as such due to the impact we predict
                  gamification can have on user activity and the number of active users and also the likelihood of
                  converting new users, I think the boost to all these metrics will contribute to a very different
                  reality by the end of June, which I believe can result in €1,500-€3,000 of revenue from this major
                  change. If we were able to somehow capture far more users, such as 500 or 1,000 such users, our
                  revenue could also be between €4,500-€9,000 in June. As such, our marketing efforts make a critical
                  difference in the full impact of each of these changes and compounds the impact.
                </li>
                <li class="roadmap-list-item-small">
                  Depending on the revenue we arrive at, we may already be able to make our first hire(s). And it may be
                  possible to hire some students for less too. It may also be possible that at stage it would be
                  possible to get my parents to invest something to match the revenue partially, and perhaps some family
                  friends, and maybe even Anshul and/or Carel or Rudolf. What's more, with these numbers, we could
                  almost certainly get Carel to join.
                </li>
              </ul>
            </div>
          </div>
          <div class="roadmap-item">
            <div class="roadmap-month">June</div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Development</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Gamification layer
                  <ul class="roadmap-sublist">
                    <li class="roadmap-list-item">
                      Themed & user-created communities
                    </li>
                    <li class="roadmap-list-item">
                      Discord / Slack style group chat experiences
                    </li>
                    <li class="roadmap-list-item">
                      Rewards & penalties (levels and XP points, badges)
                    </li>
                    <li class="roadmap-list-item">
                      Streaks
                    </li>
                    <li class="roadmap-list-item">
                      Community challenges area
                    </li>
                    <li class="roadmap-list-item">
                      Profiles reflecting achievements and participations in challenges
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Marketing</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Produce and publish ≈1 targeted audience TikTok video/day that uses a trending sound.
                </li>
                <li class="roadmap-list-item">
                  Community social media challenge that would lead people to making TikTok videos about Cofocus, even if
                  it is a testimonial.
                </li>
              </ul>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Community</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Weekly email campaign/funnel with the goal to re-engage old sign ups.
                </li>
                <li class="roadmap-list-item">
                  Weekly community poll to engage people in the conversation and increase factors of belonging, sense of
                  community, having a voice and influence, fostering relations.
                </li>
              </ul>
            </div>
            <div class="roadmap-revenue">Predicted revenue: €200</div>
            <div></div>
          </div>
          <div class="roadmap-item">
            <div class="roadmap-month">July</div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Development</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Gamification layer
                  <ul class="roadmap-sublist">
                    <li class="roadmap-list-item">
                      Personal statistics dashboard
                    </li>
                    <li class="roadmap-list-item">
                      A global leaderboard
                    </li>
                    <li class="roadmap-list-item">
                      Rewards & penalties (levels and XP points, badges)
                    </li>
                    <li class="roadmap-list-item">
                      Streaks
                    </li>
                    <li class="roadmap-list-item">
                      Community challenges area
                    </li>
                    <li class="roadmap-list-item">
                      Profiles reflecting achievements and participations in challenges
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Marketing</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Produce and publish ≈1 targeted audience TikTok video/day that uses a trending sound.
                </li>
              </ul>
            </div>
            <div class="roadmap-section">
              <div class="roadmap-section-title">Community</div>
              <ul class="roadmap-list">
                <li class="roadmap-list-item">
                  Weekly email campaign/funnel with the goal to re-engage old sign ups.
                </li>
                <li class="roadmap-list-item">
                  Weekly community poll to engage people in the conversation and increase factors of belonging, sense of
                  community, having a voice and influence, fostering relations.
                </li>
              </ul>
            </div>
            <div class="roadmap-revenue">Predicted revenue: €200</div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Financials",
  mounted() {
    this.constructFinancialForecast();
  },
  data() {
    return {
      forecastComplete: false,
      firstForecastDone: false,

      retentionPercentage: 30,
      weeklyGrowthPercentage: 4,
      avgCPM: 0.77,
      avgDurationPerView: 0.75,
      avgViewsDayPerUser: 0.33,
      nrOfUsers: 21000,
      delayFactor: 0,
      growthRateCap: 10,
      retentionRateCap: 40,
      investment: false,
      investmentSize: 125000,
      premiumPrice: 3,
      CPMGrowthRate: 0.05,
      CPMGrowthRateCap: 0.2,

      nrOfActiveUsers: 10000,
      CPM: 2.5,
      monthlyViewsPerActiveUser: 450,

      averageDurationPerViewInMinutes: 3,

      subscriberFee: 5,

      refreshIntervalInSeconds: 60,

      showFormula: false,

      months: [
        {
          name: "May",
        },
        {
          name: "June",
        },
        {
          name: "July",
        },
        {
          name: "August",
        },
        {
          name: "September",
        },
        {
          name: "October",
        },
        {
          name: "November",
        },
        {
          name: "December",
        },
        {
          name: "January 2023",
        },
        {
          name: "February",
        },
        {
          name: "March",
        },
        {
          name: "April",
        },
        {
          name: "May",
        },
        {
          name: "June",
        },
        {
          name: "July",
        },
        {
          name: "August",
        },
        {
          name: "September",
        },
        {
          name: "October",
        },
      ],

      testimonials: [
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.42.54_AM_fLx_8m4xV.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027804163",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.45.37_AM_sq9QvqKoq.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027805230",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.46.57_AM_H2ZHP40IE.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027805223",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.45.37_AM_sq9QvqKoq.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027805230",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.43.43_AM_IMZRopURU.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027804007",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.44.05_AM_o-ErByCeY.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027804752",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.44.28_AM_9dsj7oFCq.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027804889",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_5.43.54_AM_9jeGiLeur.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651027804451",
        "https://ik.imagekit.io/elysiumone/Testimonials/Screen_Shot_2022-04-27_at_6.23.10_AM_HL7P25rt9.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651029796132",
      ],
    };
  },
  computed: {
    potentialRevenue() {
      const revenue = this.computePotentialRevenue();
      return this.numberWithCommas(revenue);
    },

    computeSubscribersCount() {
      const potentialRevenue = this.computePotentialRevenue();
      const subscribersCount = potentialRevenue / this.subscriberFee;
      return this.numberWithCommas(subscribersCount.toFixed(0));
    },

    totalNumberOfImpressionsMonth() {
      const totalImpressions = this.nrOfActiveUsers * this.monthlyViewsPerActiveUser;
      return this.numberWithCommas(totalImpressions);
    },

    /* An ad runs per 'refreshRate'. With the duration provided
    for each impression, it can be calculated how many times
    a refersh can fit inside the total amount of time spent. */
    totalNrOfAdsRunPerImpression() {
      return this.computeTotalNrOfAdsRunPerView();
    },

    revenuePerPageView() {
      const revenue = this.computeTotalRevenuePerPageView();
      return this.roundNumberToDecimalPlaces(revenue, 4);
    },

    refreshFactor() {
      const factor = this.computeRefreshFactor();
      return this.roundNumberToDecimalPlaces(factor, 2);
    },

    regularViewPercentageOfRevenue() {
      const percentage = this.computeRegularViewPercentageOfRevenue();
      return this.roundNumberToDecimalPlaces(percentage, 2);
    },

    refreshPercentageOfRevenue() {
      const percentage = this.computeRefreshPercentageOfRevenue();
      return this.roundNumberToDecimalPlaces(percentage, 2);
    },
  },

  methods: {
    numberWithCommas(n) {
      if (n === undefined) return 424242;
      return n.toString().replace(/\B(?!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },

    roundNumberToDecimalPlaces(num, decimalNr) {
      return num.toFixed(decimalNr);
      /*       return Number(
        new Intl.NumberFormat("en-US", {
          minimumFractionDigits: decimalNr,
          maximumFractionDigits: decimalNr,
        }).format(num)
      ); */
    },

    computeSingleUserMonthlyRevenue() {
      const nrOfImpressionsPerView = this.computeTotalNrOfAdsRunPerView();
      const totalMonthlyImpressionsPerUser = this.monthlyViewsPerActiveUser * nrOfImpressionsPerView;

      const nrOfThousandViewsAMonthByUser = totalMonthlyImpressionsPerUser / 1000; // how many times 1000 impressions fit inside total impressions
      const singleUserMonthlyRevenue = nrOfThousandViewsAMonthByUser * this.CPM;
      return singleUserMonthlyRevenue;
    },

    computePotentialRevenue() {
      const singleUserMonthlyRevenue = this.computeSingleUserMonthlyRevenue();
      const potentialRevenue = singleUserMonthlyRevenue * this.nrOfActiveUsers;
      return this.roundNumberToDecimalPlaces(potentialRevenue, 2);
    },

    computeRefreshShareOfRevenue() {
      const singleUserRevenueWithoutRefresh = (this.monthlyViewsPerActiveUser / 1000) * this.CPM;
      const refreshFactor = this.computeRefreshFactor();
      const refreshFactorIncrease = singleUserRevenueWithoutRefresh * refreshFactor;
      const refreshShareOfRevenue = refreshFactorIncrease * this.nrOfActiveUsers;
      return refreshShareOfRevenue;
    },

    computeRegularViewPercentageOfRevenue() {
      const totalRevenue = this.computePotentialRevenue();
      const refreshRevenue = this.computeRefreshShareOfRevenue();
      const regularViewRevenue = totalRevenue - refreshRevenue;
      const percentage = (regularViewRevenue / totalRevenue) * 100;
      return percentage;
    },

    computeRefreshPercentageOfRevenue() {
      const totalRevenue = this.computePotentialRevenue();
      const refreshRevenue = this.computeRefreshShareOfRevenue();
      const percentage = (refreshRevenue / totalRevenue) * 100; // smaller by bigger
      return percentage;
    },

    /* Extract factor for how much to increase base revenue by per-refreshes */
    computeRefreshFactor() {
      const nrOfImpressions = this.computeTotalNrOfAdsRunPerView();
      const nrOfImpressionsFromRefreshes = nrOfImpressions - 1; // 1 is always default impression per view
      const refreshPercentageFromTotalImpressions = (nrOfImpressionsFromRefreshes / 1) * 100; // percentage by which total nr of impressions is bigger than default nr of impressions
      const refreshFactor = refreshPercentageFromTotalImpressions / 100; // get decimal from percentage
      return refreshFactor;
    },

    /* An ad runs per 'refreshRate'. With the duration provided
    for each impression, it can be calculated how many times
    a refersh can fit inside the total amount of time spent. */
    computeTotalNrOfAdsRunPerView(minutes = null) {
      const averageDurationPerViewInSeconds = minutes ? minutes * 60 : this.averageDurationPerViewInMinutes * 60;
      const totalRefreshesPerView = averageDurationPerViewInSeconds / this.refreshIntervalInSeconds; // how many refreshes fit inside total time spent, e.g. if refreshInterval is 60 seconds, then it won't run in 59 and total refreshes will be 0
      const totalAdsPerView = 1 + totalRefreshesPerView;
      return totalAdsPerView;
    },

    computeTotalRevenuePerPageView() {
      const nrOfImpressions = this.computeTotalNrOfAdsRunPerView();
      const revenuePerPageView = nrOfImpressions * (this.CPM / 1000);
      return revenuePerPageView;
    },

    /* Increase the values that grow month to month */
    endOfMonthIncrease(data) {
      /* Increase retention rate by 6% until 40% */
      data.retentionRate = data.retentionRate + 6;
      if (data.retentionRate > this.retentionRateCap) {
        data.retentionRate = this.retentionRateCap;
      }

      /* Increase new user growth speed by 1% until it is 10% */
      data.growthRate = data.growthRate + 1;
      if (this.investment && data.breakeven === false) {
        data.growthRate = data.growthRate + (this.investmentSize * 0.3) / 25000;
      }
      if (data.growthRate > this.growthRateCap) {
        data.growthRate = this.growthRateCap;
      }

      /* ===== Increases number of sign ups for month by weekly growth rate ===== */
      /* Week 1 increase */
      let increase = (data.nrOfUsers / 100) * data.growthRate;
      data.nrOfUsers = data.nrOfUsers + increase;
      /* Week 2 increase */
      increase = (data.nrOfUsers / 100) * data.growthRate;
      data.nrOfUsers = data.nrOfUsers + increase;
      /* Week 3 increase */
      increase = (data.nrOfUsers / 100) * data.growthRate;
      data.nrOfUsers = data.nrOfUsers + increase;
      /* Week 4 increase */
      increase = (data.nrOfUsers / 100) * data.growthRate;
      data.nrOfUsers = data.nrOfUsers + increase;

      /* ===== Per developer, to a limit, multiply newAreasAddedMonthlyRate with decreasing factor as team grows ===== */
      /* For every 4000, we increase team and returns come in the second month */
      let developmentMultiplier = Math.trunc(data.developmentBudget / 4000);

      if (this.investment && data.breakeven === false && data.month !== "May") {
        developmentMultiplier = developmentMultiplier + (this.investmentSize / 4000) * 0.08;
      }

      /* For every 4 developers, due to QA engineers and complexity, things may slightly slow down, so we do -1 */
      const slowingFactor = Math.trunc(developmentMultiplier / 4);
      developmentMultiplier = developmentMultiplier - slowingFactor;
      if (developmentMultiplier < 5 && developmentMultiplier > 1) {
        data.newAreasAddedMonthlyRate = data.newAreasAddedMonthlyRate * developmentMultiplier;
      } else if (developmentMultiplier > 5) {
        data.newAreasAddedMonthlyRate = 5;
      }

      /* Increase number of areas by monthly rate */
      if (data.newAreasAddedMonthlyRate) {
        data.nrOfAreas = data.nrOfAreas + data.newAreasAddedMonthlyRate;
      }

      /* ===== Splitting available cash ===== */
      /* If no investment && revenue above 4000 && */
      if (this.investment) {
        /* In the case of investment and have not yet reached breakeven */
        if (data.breakeven === false) {
          /* Then development budget is 0.08% of total cash balance*/
          data.developmentBudget = data.cashBalance * 0.08;
          data.marketingBudget = data.cashBalance * 0.04;
        } else {
          /* Otherwise it is 0.9% of the total cash balance */
          data.developmentBudget = data.cashBalance * 0.895;
          data.legalBudget = data.cashBalance * 0.005;
          data.marketingBudget = data.cashBalance * data.marketingBudgetShare;
        }
      } else if (!this.investment && data.revenue > 4000) {
        /* Calculate development budget (always 90% of cash balance) */
        data.developmentBudget = data.cashBalance * 0.895;
        data.legalBudget = data.cashBalance * 0.005;

        /* Calculate marketing budget (always 10% of revenue / total spend money allocated for each month) */
        data.marketingBudget = data.cashBalance * data.marketingBudgetShare;
      }

      /* Calculate server and database expenses */
      data.serverDBexpenses = Math.trunc(data.nrOfUsers / 20000) * 100;
      data.serverDBexpenses = data.serverDBexpenses + data.serverDBexpenses;

      if (data.nrOfAreas) {
        /* First time increases */
        if (data.nrOfAreas === 1) {
          const viewsIncrease = (data.nrOfViewsPerDay / 100) * 500;
          data.nrOfViewsPerDay = data.nrOfViewsPerDay + viewsIncrease;

          const durationIncrease = (data.durationPerView / 100) * 50;
          data.durationPerView = data.durationPerView + durationIncrease;
        }
        /* Second time increases */
        if (data.nrOfAreas === 2) {
          const viewsIncrease = (data.nrOfViewsPerDay / 100) * 100;
          data.nrOfViewsPerDay = data.nrOfViewsPerDay + viewsIncrease;

          const durationIncrease = (data.durationPerView / 100) * 30;
          data.durationPerView = data.durationPerView + durationIncrease;
        }

        /* Third time increases */
        if (data.nrOfAreas === 3) {
          const viewsIncrease = (data.nrOfViewsPerDay / 100) * 50;
          data.nrOfViewsPerDay = data.nrOfViewsPerDay + viewsIncrease;

          const durationIncrease = (data.durationPerView / 100) * 25;
          data.durationPerView = data.durationPerView + durationIncrease;
        }

        if (data.nrOfAreas > 3 && data.newAreasAddedMonthlyRate > 0) {
          let increaseRate = data.nrOfViewsPerDay > 30 ? 0.3 : 5;
          let durationIncrease = data.durationPerView > 5 ? 0.2 : 0.5;

          data.nrOfViewsPerDay = data.nrOfViewsPerDay + increaseRate;

          data.durationPerView = data.durationPerView + durationIncrease;
        }
      }

      /* Increase average CPM */
      let rate = this.CPMGrowthRate <= this.CPMGrowthRateCap ? this.CPMGrowthRate : this.CPMGrowthRateCap;
      data.CPM = data.CPM + rate;
      if (this.investment && this.investmentSize > 50000 && this.investmentSize < 200000) {
        data.CPM = data.CPM + 0.05;
      } else if (this.investment && this.investmentSize > 200000 && this.investmentSize < 500000) {
        data.CPM = data.CPM + 0.1;
      } else if (this.investment && this.investmentSize > 500000) {
        data.CPM = data.CPM + 0.15;
      }
      return data;
    },

    /**
     * We need a tool that can tell us how many views a day by how many users to which locations
     * (e.g. ad location, non ad location, etc) — because even taking average nr of views right now
     * it will also count in non-ad locations too
     *
     * we also need real data so we could calculate actually real results
     *
     * since users won't grow indefinitely, average engagement will grow
     */

    setStartingValues() {
      return {
        nrOfViewsPerDay: this.avgViewsDayPerUser, // 8 a month per user
        durationPerView: this.avgDurationPerView, // in minutes
        CPM: this.avgCPM,

        nrOfUsers: this.nrOfUsers,
        nrOfAreas: 0, // nr of highly engaging areas with an ad
        retentionRate: this.retentionPercentage, // % of users using app in total
        growthRate: this.weeklyGrowthPercentage, // growth rate of users in %
        newAreasAddedMonthlyRate: 1, // how many highly engaging areas are added

        /* Delay factor, if things are late */
        delayFactor: this.delayFactor,

        /* Delay factor for new devs */
        delayedValueOnHold: 0,

        /* Do we have investment? */
        investment: this.investment,
        investmentSize: this.investmentSize,
        breakeven: false,
        investmentAdded: false,

        /* Employees */
        developmentBudget: 0,
        marketingBudget: 0,
        legalBudget: 0,
        marketingBudgetShare: 0.1,
        serverDBexpenses: 100,

        /* Payroll & taxes */
        salaries: 0,

        /* Money */
        revenue: 100,
        supporters: 20,
        premiumPrice: this.premiumPrice,
        cashBalance: 2000,
      };
    },

    constructFinancialForecast() {
      this.forecastComplete = false;
      if (!this.firstForecastDone) this.firstForecastDone = true;
      let data = this.setStartingValues();
      data = JSON.parse(JSON.stringify(data));

      /* ===== COMPUTE FINANCES ===== */
      for (var i = 0; i < this.months.length; i++) {
        /* ===== COMPUTE REVENUE FOR MONTH ===== */
        const month = this.months[i];
        const activeUsers = data.nrOfUsers * (data.retentionRate / 100); // e.g. 15% retention rate = 0.15
        /* Calculate total nr of ads run per view */

        const averageDurationPerViewInSeconds = data.durationPerView * 60;
        const totalRefreshesPerView = averageDurationPerViewInSeconds / this.refreshIntervalInSeconds; // how many refreshes fit inside total time spent, e.g. if refreshInterval is 60 seconds, then it won't run in 59 and total refreshes will be 0
        const totalNrOfAdsRunPerView = 1 + totalRefreshesPerView;

        console.log("ACTIVE USERS: ", activeUsers);
        console.log("IMPRESSIONS PER VIEW: ", totalNrOfAdsRunPerView);
        console.log("VIEWS PER DAY PER USER: ", data.nrOfViewsPerDay);
        console.log("CPM RATE: ", data.CPM);
        const averageMonthlyImpressionsPerUser = data.nrOfViewsPerDay * totalNrOfAdsRunPerView * 30;
        const averageMonthlyRevenuePerUser = (averageMonthlyImpressionsPerUser / 1000) * data.CPM;
        let totalMonthlyRevenue = activeUsers * averageMonthlyRevenuePerUser;
        console.log("REVENUE: ", totalMonthlyRevenue);

        /* Calculate compounding value of new areas */
        let compoundingValue = data.nrOfAreas * 0.2;
        if (compoundingValue > 5) compoundingValue = 5;
        const increaseFromCompoundingValue = totalMonthlyRevenue * compoundingValue;
        totalMonthlyRevenue = totalMonthlyRevenue + increaseFromCompoundingValue;
        console.log("COMPOUNDING VALUE: ", compoundingValue);
        console.log("REVENUE POST COMPOUND: ", totalMonthlyRevenue);

        /* Factor in supporters */
        let revenueFromSupporters = data.supporters * data.premiumPrice;
        if (i !== 0) {
          let factor = 0.5;
          if (this.investment) {
            factor = 1;
          }
          const supportersIncrease = Math.trunc(data.supporters * factor);
          data.supporters = data.supporters + supportersIncrease;
          revenueFromSupporters = data.supporters * data.premiumPrice;
          totalMonthlyRevenue = totalMonthlyRevenue + revenueFromSupporters;
        }

        /* Factor in delay */
        if (data.delayFactor > 0) {
          totalMonthlyRevenue = totalMonthlyRevenue * data.delayFactor;
        }

        data["revenue"] = totalMonthlyRevenue;
        if (!month["revenue"]) month["revenue"] = {};
        let adsRevenue = totalMonthlyRevenue;
        if (i !== 0) {
          adsRevenue = totalMonthlyRevenue - revenueFromSupporters;
        }
        month["revenue"]["advertising"] = Math.trunc(adsRevenue);
        month["revenue"]["premium"] = Math.trunc(revenueFromSupporters);
        month["revenue"]["total"] = month["revenue"]["advertising"] + month["revenue"]["premium"];

        /* ===== COMPUTE EXPENSES FOR MONTH ===== */
        if (!month["expenses"]) month["expenses"] = {};
        month["expenses"]["development"] = Math.trunc(data.developmentBudget);
        month["expenses"]["legal"] = Math.trunc(data.legalBudget);
        month["expenses"]["marketing"] = Math.trunc(data.marketingBudget);
        month["expenses"]["serverDBexpenses"] = Math.trunc(data.serverDBexpenses);

        /*  Add in salaries depending on state of revenue and investment */
        if (month["revenue"]["total"] > 35000 && !this.investment) {
          month["expenses"]["salaries"] = 3000;
          month["expenses"]["development"] = month["expenses"]["development"] - 3000;
        } else if (month["revenue"]["total"] > 35000 && this.investment) {
          month["expenses"]["salaries"] = 3000;
        } else {
          month["expenses"]["salaries"] = Math.trunc(data.salaries);
        }

        /* Compute total expenses */
        month["expenses"]["total"] = Math.trunc(
          data.legalBudget + data.developmentBudget + data.marketingBudget + data.salaries + data.serverDBexpenses
        );

        /* ===== COMPUTE CASH FLOW FOR MONTH ===== */
        month["cashflow"] = month["revenue"]["total"] - month["expenses"]["total"];

        month["cashbalance"] = data.cashBalance + month["cashflow"]; // cashflow could be negative
        data.cashBalance = month["cashbalance"];

        if (data.investment && !data.investmentAdded) {
          month["cashbalance"] = month["cashbalance"] + this.investmentSize;
          month["cashflow"] = month["cashflow"] + this.investmentSize;
          month["revenue"]["investment"] = this.investmentSize;
          month["revenue"]["total"] = month["revenue"]["total"] + this.investmentSize;
          data["revenue"] = month["revenue"]["total"];
          data.cashBalance = month["cashbalance"];
          data.investmentAdded = true;
        } else if (this.investment && data.investmentAdded) {
          month["revenue"]["investment"] = 0;
          data.investmentSize = 0;
          if (month["revenue"]["total"] > 10000 && month.name !== "May" && data.breakeven === false) {
            data.breakeven = true;
          }
        }

        data["month"] = month.name;
        month["otherData"] = JSON.parse(JSON.stringify(data));

        /* ===== APPLY MONTHLY PROGRESS ===== */
        data = this.endOfMonthIncrease(data);
        data = JSON.parse(JSON.stringify(data));
      }

      this.forecastComplete = true;
    },

    /**
     *
     * [] factor in engagement increase
     * [] factor in investment —> just increase development budget by 4000x2
     *
     */
  },
  watch: {
    retentionPercentage() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    weeklyGrowthPercentage() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    avgCPM() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    avgDurationPerView() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    avgViewsDayPerUser() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    nrOfUsers() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    delayFactor() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    growthRateCap() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    retentionRateCap() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    investment() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    investmentSize() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    premiumPrice() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    CPMGrowthRate() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
    CPMGrowthRateCap() {
      if (!this.firstForecastDone) return;
      this.constructFinancialForecast();
    },
  },
};

/**
 * @todo
 * [] Make current target a link that takes to elaborated description of what the current target is and why
 */
</script>

<style scoped>
.financials {
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 36px);
  font-family: "Nunito", "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif;
  line-height: 27px;
  margin: 0 auto;
  align-items: center;
  width: 100%;
}

.core-info {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container {
  display: flex;
  width: 600px;
  flex-wrap: wrap;
  justify-content: left;
}
.section-container {
  width: 600px;
  margin: 18px 0px;
}
.stats-container {
  background-color: #eaecef;
  padding: 25px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 46%;
  margin: 5px;
}
.custom-container {
  width: unset;
}
.stats-top-text {
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 600;
}
.stats-number {
  font-weight: 700;
  font-size: 30px;
}
h2 {
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 10px;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-family: "Avenir", "Tahoma", sans-serif;
}
.stats-box {
  margin-bottom: 15px;
}
.flex {
  display: flex;
}
.column-flex {
  display: flex;
  flex-direction: column;
}
.table-container {
  width: 100% !important;
  display: flex;
  /* overflow-x: scroll; */
}
table {
  display: block;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 15px;
}
table,
th,
td {
  border: 1px solid #696969;
}
td {
  width: 125px;
  min-width: 125px;
  padding: 0px 5px;
}
.head-title {
  font-weight: 700;
  font-size: 20px;
  text-align: left;
  padding: 0px 5px;
}
.head-title-2 {
  font-weight: 700;
  text-align: left;
  padding: 0px 5px;
}
.special {
  height: 50px;
}
.special-2 {
  height: 10px;
}
.special-2 th {
  border-right-color: transparent;
}
.special th {
  border-top-color: transparent;
  border-right-color: transparent;
}
.special-box {
  height: 50px;
  border-color: transparent;
  text-align: right;
  padding: 0px 5px;
}
.special-box-2 {
  height: 10px;
  border-color: transparent;
  text-align: right;
  padding: 0px 5px;
  border-bottom: 1px solid #696969;
}
.variables {
  background-color: violet;
}
.revenue {
  background-color: #7ef875;
  background-color: #222;
  color: white;
}
.expenses {
  background-color: #ff4d4d;
  background-color: #222;
  color: white;
}

/* ROADMAP ITEMS */
.roadmap-item {
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px;
  margin: 20px 0px;
}
.classic-list-item {
  list-style: disc;
  margin-left: 20px;
}
.roadmap-list {
  margin: 10px 0px;
}
.roadmap-sublist {
}
.roadmap-list-item {
  list-style: disc;
  margin: 5px 0px;
  margin-left: 22px;
  padding-left: 5px;
}
.roadmap-section-title-small {
  margin-top: 10px;
  margin-bottom: -5px;
  font-size: 16px;
  font-weight: 600;
}
.roadmap-list-item-small {
  font-size: 14px;
  line-height: 21px;
  list-style: disc;
  margin: 3px 0px;
  margin-left: 22px;
  padding-left: 5px;
}
.roadmap-text-small {
  font-size: 14px;
  line-height: 21px;
  margin: 3px 0px;
}
.roadmap-section-small {
  border-radius: 12px;
  padding: 1px 10px;
  background-color: #f4f4f4;
}
.roadmap-month {
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 10px;
}
.roadmap-revenue {
  position: absolute;
  bottom: 10px;
  right: 15px;
}
.roadmap-section-title {
  font-size: 20px;
}
.roadmap-section {
  margin: 10px 0px;
}
.roadmap-outcomes {
  position: absolute;
  top: 0;
  right: -375px;
  background-color: #f4f4f4;
  width: 350px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px;
}
.money-box {
  text-align: right;
  padding: 0px 5px;
  border: 1px solid #696969 !important;
}
.recalc {
  padding: 10px;
  background-color: #222;
  color: white;
  font-weight: 600;
  border-radius: 360px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
  cursor: pointer;
}
.recalc:hover {
  background-color: #444;
}
table {
  border-color: transparent !important;
}
.roman-list {
  list-style: lower-roman;
}
.formulaToggle {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  border: 1px solid #5f5e5e;
  padding: 4px 10px;
  border-radius: 360px;
  cursor: pointer;
  width: 300px;
}
.formulaToggle:hover {
  background-color: #f2f2f2;
}
.special-top {
  padding-top: 10px;
}
.testimonials {
  display: flex;
  flex-wrap: wrap;
  width: 600px;
}
.testimonial {
  width: 100%;
  margin-bottom: 15px;
  border-radius: 10px;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px;
}
input[type="number"] {
  font-family: "Nunito";
}
</style>
